<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configuration-target-contact-reasons" v-loading="loading">
    <div class="title-btns-section"> 
      <div class="title">Conversation Topics Targets</div>
      <div v-if="showSearchSection" class="update-btns">
        <!-- <div class="update-cancel-btn" @click="controller.appVue.handleAppModalClose">Cancel</div> -->
        <button :class="(isDisabled?'update-save-btn disabled':'update-save-btn')"  :disabled="isDisabled" @click="updateTargets">Update</button>
      </div>
    </div>
    <div v-if="showSearchSection" class="search-section">
      <div class="keyword-input">
        <el-input
          ref="searchTargets"
          class="search-targets"
          placeholder="Search conversation topics"
          v-model="searchKeywordInput"
        ></el-input>
        <i v-if="searchKeywordInput!=''" class="fas fa-times-circle" @click="clearSearchInput"></i>
      </div>
      <div v-if="$refs.targetContactReasonTable && $refs.targetContactReasonTable.tableData" class="btn-section" :class="{'disabled':($refs.targetContactReasonTable.tableData.length==0)}">
        <div class="clear-all-btn" @click="handleClearAllTargets(configrationData)"><span>Clear all targets</span></div>
        <div class="reset-all-btn" @click="handleDiscardUnsavedChanges"><span>Discard unsaved changes</span></div>
      </div>
    </div>
    <div class="content-section"> 
      <wy-table-list ref="targetContactReasonTable" :controller="module" :configrationData="configrationData" :tableColumns="tableColumns" :contactReasonsData="contactReasonsData" :searchKeywordInput="searchKeywordInput" :enableSelection="true" :mode="'generic'" />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import WyTableList from '../../widgets/wy-table-list-targets';

  export default {
    name: 'wy-configuration-target-contact-reasons',
    components: {
      'wy-table-list': WyTableList,
    },
    props: ['controller'],
    
    data() {
      return {
        module: this,
        loading: false,
        searchKeyword: '',
        searchKeywordInput: '',
        showSearchSection: true,
        contactReasonsData: {},
        tableColumns: [
          // {label: "Contact Reasons", name: "contactReasonsName", type: "targetRange", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'Bes Target', cssClass: 'bes-target', align:"left", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "Conversation Topics", type:"contactReason", name: "name", mandatory: true, selected: true, sortable: true, group: 'Conversation Topics ', align:"left", minWidth: 350, fixed: true, mainColumn: true, copyable: false, isEditTopicName: false, extendableField: true},
          {label: "Volume", name: "volume", selected: true, sortable: true, group: 'Volume', minWidth: 100, align:"right"},
          {label: "BES Target", name: "besTarget", type: "targetRange", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Bes Target', cssClass: 'bes-target', align:"left", minWidth: 260, fixed: false, copyable: false, isEditTopicName: false},
          {label: "BAS Target", name: "basTarget", type: "targetRange", mandatory: true, selected: true, sortable: false, hasSubtitle: false, group: 'Bas Target', cssClass: 'bas-target', align:"right", minWidth: 260, fixed: false, copyable: false, isEditTopicName: false}
        ],
        tableData: {
          data:[]
        },
        tableDataClone: {
          data:[]
        },
        originTableData: {},
        configrationData: [],
        configrationDataClone: [],
        originCompanySettingData: null,
        isEditing: false,
        disableSection: false
      };
    },

    computed: {
      ...mapGetters(['dataModel', 'isRoleAllow', 'companyConfig', 'companyProfileSettings']),

      isDisabled() {
        return !this.controller.hasNoSavedChanges
      }
    },

    methods: {
      ...mapMutations(['updateDataModelColumns']),
      ...mapActions(['fetchContactReasonsForTargets', 'updateCompanyProfileSettings']),

      clearSearchInput() {
        this.searchKeywordInput = '';
      },

      convertFormat(data) {
        data.data.forEach((item)=> {
          item.name = item.contactReason
        })
      },

      handleDiscardUnsavedChanges() {
        this.controller.hasNoSavedChanges = false;
        this.controller.hasError = false;
        this.isEditing = false;
        if(!this.originCompanySettingData || !this.originCompanySettingData.targetSettings) {
          this.companyProfileSettings.targetSettings = null
        }
        else {
          this.companyProfileSettings.targetSettings = this.originCompanySettingData.targetSettings
        }
        if(this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings && this.companyProfileSettings.targetSettings.settings.home) {
          this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
          if(this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary && this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.contactReasons) {
            this.configrationData = this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.contactReasons;
          }
          else {
            this.configrationData = [];
          }
        }
        else {
          this.configrationData = []
        }
        this.loading = true;
        this.tableData = JSON.parse(JSON.stringify(this.originTableData));
        this.$refs.targetContactReasonTable.contactReasonsData = this.tableData;
        const temSearchKeyword = this.searchKeywordInput;
        this.searchKeywordInput = ''
        this.$refs.targetContactReasonTable.refreshTable();
        setTimeout(()=>{
          this.searchKeywordInput = temSearchKeyword
        }, 200)
      },

      handleClearAllTargets() {
        this.controller.hasError = false;
        this.$refs.targetContactReasonTable.tableData.forEach((item, index) => {
          if(Object.keys(item).length > 0) {
            Object.keys(item).forEach(key => {
              if(item[key] && (item[key].value || item[key].value == 0)) {
                this.$refs.targetContactReasonTable.removeTargetValue(item[key], this.$refs.targetContactReasonTable.$refs['numberComponent'+key+index])
              }
            })
          }
        })
      },

      async prepareData() {
        this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
        if(this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings.home) {
          if(this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.contactReasons) {
            this.configrationData = this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.contactReasons;
          }
        }
        await this.fetchContactReasons({forceRefresh: true, logEvent: true});
      },
      
      async fetchContactReasons(options) {
        if((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
          this.loading = true;
          let data = await this.fetchContactReasonsForTargets(options);      
          if(this.$refs.targetContactReasonTable) {
            if(data && data.data) {
              this.convertFormat(data)
              if(data.data.length== 0) {
                this.showSearchSection = false;
              }
              this.tableData = data;
              this.$refs.targetContactReasonTable.contactReasonsData = data;
              const temSearchKeyword = this.searchKeywordInput;
              this.searchKeywordInput = ''
              this.$refs.targetContactReasonTable.refreshTable();
              setTimeout(()=>{
                this.searchKeywordInput = temSearchKeyword
              }, 100)
              if(this.tableDataClone && this.tableDataClone.data.length == 0) {
                this.tableDataClone.data = JSON.parse(JSON.stringify(this.$refs.targetContactReasonTable.tableData));
                this.originTableData = JSON.parse(JSON.stringify(this.tableDataClone));
              }
            }
          }
          // this.loading = true;
        }
        else {
          this.$refs.targetContactReasonTable.contactReasonsData = {data:[]};
          this.$refs.targetContactReasonTable.refreshTable();
        }
      },
      async updateTargets() {
        this.configrationData = this.checkSettingsActived(this.configrationData)
        if(!this.companyProfileSettings || !this.companyProfileSettings.targetSettings) {
          this.companyProfileSettings.targetSettings = {settings: {}}
        }
        let companyProfileSettingsLocal = this.companyProfileSettings.targetSettings.settings;
        if(!companyProfileSettingsLocal.home) {
          companyProfileSettingsLocal.home = {
            experienceAutomationSummary: {
              contactReasons: []
            }
          }
        }
        companyProfileSettingsLocal.home.experienceAutomationSummary.contactReasons = this.configrationData;

        this.loading = true;
        let success = await this.updateCompanyProfileSettings(companyProfileSettingsLocal);
        if(success) {
          this.loading = false;
          this.controller.hasNoSavedChanges = false;
          this.controller.isDashBoardModified = true;
          this.tableDataClone = JSON.parse(JSON.stringify(this.tableData));
          let newArr = [];
          this.originTableData.data.forEach(item=>{
            let obj = item;
            JSON.parse(JSON.stringify(this.tableDataClone)).data.forEach(tableItem => {
              if(item.name == tableItem.name) {
                item = JSON.parse(JSON.stringify(tableItem))
                item.besTarget = tableItem.besTarget
                item.basTarget = tableItem.basTarget
                obj = tableItem;
              }
            })
            newArr.push(obj)
          })
          this.originTableData.data = newArr;
          this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
          this.$message({
            showClose: true,
            message: this.$t("configurations.targetUpdateSuccess"),
            customClass: 'configuration-success-message',
            duration: 5000,
            type: 'success'
          });
        }
        else {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t("configurations.targetUpdateFailed"),
            customClass: 'configuration-failed-message',
            duration: 5000,
            type: 'error'
          });
        }
      },
      checkSettingsActived(data) {
        let newList = [];
        data.forEach(item => {
          let actived = false;
          Object.keys(item.target).forEach(key => {
            if(item.target[key].value || item.target[key].value == 0) {
              item.target[key].value = Number(item.target[key].value);
              actived = true;
            }
          })
          if(actived) {
            newList.push(item)
          }
        })
        // data.forEach(item => {
        //   item.actived = actived;
        // })
        return newList;
      },
      updatedTargetList(target) {
        // if(target.besTarget.value == '') target.besTarget.value = null;
        // if(target.basTarget.value == '') target.basTarget.value = null;
        let duplicate = false;
        this.configrationData.forEach(selectedTarget => {
          if(selectedTarget.name == target.name) {
            duplicate = true;
          }
        })
        if(!duplicate) {
          let newTarget = {
            name: target.name,
            key: target.name,
            actived: true,
            target: {
              bes: target.besTarget,
              bas: target.basTarget,
            }
          }
          this.configrationData.push(newTarget)
        }
      },

      handleSaveUnchanges(newTab, handleAppModalClose) {
        this.controller.$refs.updateDialog.title = `Review changes`;
        this.controller.$refs.updateDialog.content="There are unsaved changes. Do you want to discard or save them before leaving?" 
        this.controller.$refs.updateDialog.open();
        if(this.controller.hasError) {
          this.controller.$refs.updateDialog.disableSaveBtn = true;
        }
        else {
          this.controller.$refs.updateDialog.disableSaveBtn = false;
        }
        this.controller.$refs.updateDialog.confirmButtonCallback = async () => {
          this.updateTargets()
          this.controller.hasNoSavedChanges = false;
          if(handleAppModalClose) {
            handleAppModalClose();
          }
          else {
            this.controller.handleTabClick({name: newTab})
            this.controller.activeTab = newTab
          }
        }
        this.controller.$refs.updateDialog.discardButtonCallback = async () => {
          this.handleDiscardUnsavedChanges();
          
          if(handleAppModalClose) {
            handleAppModalClose();
          }
          else {
            this.controller.handleTabClick({name: newTab})
            this.controller.activeTab = newTab;
          }
        }
      }
    }
  };
</script>

<style lang="scss">
  .wy-configuration-target-contact-reasons {
    .wy-table-list .wy-table-wrapper {
      border-radius: 0px !important;
      overflow-y: hidden;
      // border-right: 1px solid #CAD2DA;
    }
    .wy-table-list.targets .wy-table-main tbody {
      // height: calc( 100vh - 516px);
      height: calc( 100vh - 370px);
      width: calc(100vw - 371px);
      border-right: 1px solid #CAD2DA;
      border-bottom: 1px solid #CAD2DA;
      overflow-y: scroll;
    }
    .wy-table-list.targets .wy-table-fixed {
      border-left: 1px solid #CAD2DA;
      // height: calc(100vh - 477px);
      height: calc( 100vh - 370px);
      tbody {
        // height: calc( 100vh - 516px);
        max-height: unset !important;
      }
    }
    .wy-table-main thead tr {
      width: calc( 100vw - 372px);
    }
    .wy-table-list.targets thead {
      background-color: #FFF;
      padding: 0px;
      border: 1px solid #cad2da;
      border-left: 0px;
      border-right: 1px;
      
    }
    .wy-table-list.targets tbody tr td {
      border-bottom: 0px solid #eee;
    }
    .wy-table-list.targets thead tr th {
      color: var(--site-font-secondary-color);
    }
    .wy-table-list .wy-table-fixed tbody tr td:first-child {
      background-color: #FFFF;
    }
    .wy-table-list.targets .wy-table-main thead th {
      background-color: transparent;
    }
    .wy-table-list.targets .wy-table-main tbody tr {
      width: calc( 100vw - 745px);
      td div {
        justify-content: left;
      }
    }
    .wy-table-list.targets .wy-sub-header .wy-table-tail {
      // border-right: 1px solid #CAD2DA;
      // min-width: 4px;
    }
    .wy-table-list.targets .wy-table-main thead {
      background-color: #FFF;
      border: 1px solid #CAD2DA;
      border-left: 0px;
      border-right: 1px solid #CAD2DA;
      width: calc(100vw - 371px) !important;
    }
    .wy-table-list.targets .wy-table-tail {
      min-width: 0px;
    }
    .wy-table-list.targets .wy-table-main thead {
      .wy-sub-header {
        // width: calc( 100vw - 644px);
        background: transparent;
        border-bottom: 0px;
        th {
          text-align: left;
        }
        th:nth-child(2) {
          span {
            padding-left: 0px;
          }
        }
      }
    }
    .wy-table-fixed thead {
      border-right: 0px;
      border-bottom: 0px !important;
      .wy-sub-header th.lastChild {
        border-right: 0px solid #fff;
      }
    }
    .wy-table-main thead th {
      background-color: #FFF;
    }
    .search-section {
      padding: 20px 0px;
      display: flex;
      .keyword-input {
        display: flex;
        width: 304px;
        margin-right: auto;
        input {
          border-width: 1px !important;
          height: 30px;
          font-size: 15px;
          padding-left: 15px;
          padding-right: 30px;
          padding-bottom: 2px;
          border-radius: 5px;
          width: 288px;
        }
        .fas.fa-times-circle {
          cursor: pointer;
          position: relative;
          top: 7px;
          left: -25px;
        }
      }
    }
    .btn-section {
      display: flex;
      // width: 425px;
      .clear-all-btn {
        font-size: 12px;
        width: 105px;
        line-height: 2.5;
        color: #106FBC;
        cursor: pointer;
      }
      .reset-all-btn {
        font-size: 12px;
        width: 150px;
        text-align: right;
        line-height: 2.5;
        color: #106FBC;
        cursor: pointer;
      }
    }
    .btn-section.disabled {
      pointer-events: none;
      opacity: 0.4;
    }
    .title-btns-section {
      display: inline-flex;
      width: 100%;
      .title {
        line-height: 2;
        font-size: 15px;
        font-weight: 700;
      }
      .update-btns {
        display: inline-flex;
        margin-left: auto;
      }
      .update-cancel-btn {
        color: #202223 !important;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-weight: 400;
        padding: 8px 16px 8px 16px;
        display: flex;
        border-radius: 5px;
        height: fit-content;
        width: fit-content;
        border: 1px solid #CAD2DA;
        cursor: pointer;
        background: white;
        margin-right: 15px;
        align-items: center;
        justify-content: center;
        &:hover{
          background: #F4F6F8;
        }
      }
      .update-save-btn {
        width: fit-content;
        height: fit-content;
        padding: 8px 16px 8px 16px;
        font-size: 15px;
        cursor: pointer;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color) !important;
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        border-radius: 5px;
        // margin-right: 15px;
        align-items: center;
        justify-content: center;
      }
      .update-save-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .update-save-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn.disabled {
        background: var(--site-button-primary-btn-disabled-background-primary-color);
        cursor: not-allowed;
      }
      .update-save-btn.disabled:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn.disabled:active {
        background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
      }
      .update-save-btn.disabled:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .intent-action-dropdown-save-btn:disabled{
        background: #C0C4CC;
        cursor: not-allowed;
      }
    }
    .el-loading-mask {
      height: calc(100vh - 200px);
    }
    .wy-page-nodata-with-available-date-range {
      margin-top: 0%;
      height: calc(100vh/2);
    }
    .no-data-section {
      border: 1px solid #cad2da !important;
      .wy-table-main {
        border-right: 0px solid #CAD2DA !important;
        border-bottom: 0px solid #cad2da !important;
        // border-left: 1px solid #CAD2DA;
        thead {
          border: 0px solid #CAD2DA !important;
          border-bottom: 1px solid #CAD2DA !important;
          tr.wy-sub-header > th:first-child {
            border-left: 1px solid transparent;
          }
        }
        thead .wy-sub-header {
          border-right: 1px solid #CAD2DA;
          th span {
            padding-left: 0px;
          }
          th:first-child {
            span {
              padding-left: 12px;
            }
          }
        }
        thead tr {
          width: calc(100vw - 372px) !important;
        }
          tbody {
          overflow-y: hidden !important;
          border-right: 0px solid #CAD2DA !important;
          border-bottom: 0px solid #eee !important;
          border-left: 0px solid #CAD2DA !important;
        }
      }


      // border: 1px solid #cad2da !important;
      // .wy-table-main {
      //   border-right: 0px solid #CAD2DA !important;
      //   border-bottom: 1px solid #cad2da !important;
      //   thead {
      //     border: 0px solid #CAD2DA !important;
      //     border-bottom: 1px solid #CAD2DA !important;
      //     tr.wy-sub-header > th:first-child {
      //       border-left: 1px solid transparent;
      //     }
      //   }
      //   thead .wy-sub-header {
      //     th:first-child {
      //       span {
      //         padding-left: 12px;
      //       }
      //     }
      //   }
      //   tbody {
      //     overflow-y: hidden;
      //     border-right: 0px solid #CAD2DA !important;
      //     border-bottom: 0px solid #eee !important;
      //     border-left: 0px solid #CAD2DA !important;
      //   }
      // }
    }
  }
  .configuration-success-message {
    background-color: #D9EEDF;
    border-color: #86D2AE;
    .el-icon-success {
      color: #186731;
    }
    .el-message__content {
      color: var(--site-font-secondary-color);
    }
  }
</style>